var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.55 13.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.28,0C5.94,0,0,5.94,0,13.28H26.55c0-7.33-5.94-13.28-13.28-13.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeImpact);
export default __webpack_public_path__ + "static/media/gauge-impact.c55ad7b44076158162046b8b9452d419.svg";
export { ForwardRef as ReactComponent };